<template>
  <div>
    <b-card
      header="Business Profile"
      header-text-variant="light"
      header-tag="header"
      header-class="header-color"
    >
      <!-- RestaurantName -->
      <b-row class="my-1 d-none d-sm-flex">
        <b-col cols="12" lg="6">
          <b-row>
            <b-col cols="10" lg="9">
              <b-input-group
                :class="readonlyRestaurantName ? 'remove-border-styling' : ''"
                prepend="Restaurant Name"
              >
                <b-form-input
                  placeholder="Required"
                  v-model="businessProfile.RestaurantName"
                  :readonly="readonlyRestaurantName"
                  maxlength="50"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    v-if="readonlyRestaurantName == false"
                    @click="updateRestaurantName"
                    :disabled="
                      businessProfile.RestaurantName.length ? false : true
                    "
                    variant="success"
                    size="sm"
                    >Save Changes</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="2" lg="3" sm="md">
              <b-button
                v-if="readonlyRestaurantName == true"
                @click="readonlyRestaurantName = false"
                variant="link"
                >Edit
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- //RestaurantName -->

      <!-- Restaurant Name Mobile View -->
      <b-row class="my-1 d-block d-sm-none">
        <b-col cols="12" lg="6">
          <b-row>
            <b-col cols="11">
              <b-row class="pl-2"
                ><label
                  style="font-size: 0.875rem; font-weight: 400; color: gray;"
                  >Restaurant Name</label
                ></b-row
              >
              <b-row :class="readonlyRestaurantName ? '' : 'pl-2'"
                ><b-input-group
                  :class="
                    readonlyRestaurantName ? 'remove-border-styling' : 'px-0'
                  "
                >
                  <b-form-input
                    placeholder="Required"
                    v-model="businessProfile.RestaurantName"
                    :readonly="readonlyRestaurantName"
                    maxlength="50"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      v-if="readonlyRestaurantName == false"
                      @click="updateRestaurantName"
                      :disabled="
                        businessProfile.RestaurantName.length ? false : true
                      "
                      variant="success"
                      size="sm"
                      >Save
                    </b-button>
                    <b-button
                      v-if="readonlyRestaurantName == true"
                      @click="readonlyRestaurantName = false"
                      variant="link"
                      >Edit
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- //Restaurant Name Mobile View -->

      <!-- Restaurant Details -->
      <b-row class="mt-5 mb-3">
        <!-- Restaurant Address panel -->
        <b-col cols="12" sm="12" md="12" lg="6">
          <!-- Restaurant Address -->
          <b-row style="padding-left: 12px;" class="d-none d-sm-flex">
            <b-col cols="10" lg="9">
              <b-row>
                <b-col sm="4"
                  ><label
                    for="input-default"
                    style="font-size: 0.875rem; font-weight: 400; color: gray; "
                    >Restaurant Address</label
                  ></b-col
                >
              </b-row>
              <b-row>
                <b-col sm="8">
                  <b-input
                    class="address-input"
                    placeholder="Required"
                    readonly
                    :value="businessProfile.Address1"
                  ></b-input>
                  <b-input
                    v-if="businessProfile.Address2.length > 1"
                    class="address-input"
                    placeholder="Optional"
                    readonly
                    :value="businessProfile.Address2"
                  ></b-input>
                  <b-input
                    class="address-input"
                    placeholder="Required"
                    readonly
                    :value="
                      businessProfile.City +
                        ', ' +
                        businessProfile.State +
                        ' ' +
                        businessProfile.ZIP
                    "
                  ></b-input>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="2" lg="3">
              <b-button
                class="pt-0"
                @click="addressModal = true"
                v-b-modal.modal-1
                variant="link"
                >Edit
              </b-button></b-col
            >

            <!-- Address Modal -->
            <CModal
              id="modal-1"
              v-model="addressModal"
              title="Restaurant Address Edit"
              :tag="false"
            >
              <b-input-group class="mt-4" prepend="Address line 1">
                <b-form-input
                  v-model="businessProfile.Address1"
                  placeholder="Required"
                ></b-form-input>
              </b-input-group>
              <b-input-group class="mt-4" prepend="Address line 2">
                <b-form-input
                  v-model="businessProfile.Address2"
                  placeholder="Optional"
                ></b-form-input>
              </b-input-group>
              <b-row style="align-items: center;">
                <b-col>
                  <b-input-group class="mt-4" prepend="Zip Code">
                    <b-form-input
                      v-model="businessProfile.ZIP"
                    ></b-form-input> </b-input-group
                ></b-col>
                <b-col>
                  <b-input-group class="mt-4" prepend="City">
                    <b-form-input v-model="businessProfile.City"></b-form-input>
                  </b-input-group>
                  <b-input-group class="mt-4" prepend="State">
                    <b-form-input
                      v-model="businessProfile.State"
                    ></b-form-input> </b-input-group
                ></b-col>
              </b-row>
              <!-- Address Modal Save and Cancel button -->
              <template #actions>
                <b-row class="flex-grow-1">
                  <b-col cols="6">
                    <b-btn
                      block
                      variant="warning"
                      size="md"
                      class="float-right ml-3"
                      @click="updateAddress"
                    >
                      Save Changes
                    </b-btn>
                  </b-col>

                  <b-col cols="6">
                    <b-btn
                      variant="danger"
                      size="md"
                      block
                      class="text-nowrap cancel-btn-cmodal"
                      @click="addressModal = false"
                    >
                      Cancel
                    </b-btn>
<!--                    <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="hide">-->
<!--                      Cancel-->
<!--                    </b-btn>-->
                  </b-col>
                </b-row>
              </template>
            </CModal>
          </b-row>
          <!-- //Restaurant Address -->

          <!-- Mobile View Restaurant Address -->
          <b-row class="d-block d-sm-none">
            <b-col cols="11">
              <b-row class="pl-2">
                <label
                  for="input-default"
                  style="font-size: 0.875rem; font-weight: 400; color: gray; "
                  >Restaurant Address</label
                >
              </b-row>
              <b-row>
                <b-input-group>
                  <b-form-input
                    class="address-input"
                    placeholder="Required"
                    readonly
                    :value="businessProfile.Address1"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      @click="addressModal = true"
                      v-b-modal.modal-1
                      variant="link"
                      >Edit
                    </b-button>
                  </b-input-group-append>
                </b-input-group>

                <b-input
                  class="address-input"
                  placeholder="Optional"
                  readonly
                  :value="businessProfile.Address2"
                ></b-input>
                <b-input
                  class="address-input"
                  placeholder="Required"
                  readonly
                  :value="
                    businessProfile.City +
                      ', ' +
                      businessProfile.State +
                      ' ' +
                      businessProfile.ZIP
                  "
                ></b-input>
              </b-row>
            </b-col>

            <!-- Address Modal -->
<!--            <b-modal-->
<!--              id="modal-1"-->
<!--              v-model="addressModal"-->
<!--              title="Restaurant Address Edit"-->
<!--            >-->
<!--              <b-input-group class="mt-4" prepend="Address line 1">-->
<!--                <b-form-input-->
<!--                  v-model="businessProfile.Address1"-->
<!--                  placeholder="Required"-->
<!--                ></b-form-input>-->
<!--              </b-input-group>-->
<!--              <b-input-group class="mt-4" prepend="Address line 2">-->
<!--                <b-form-input-->
<!--                  v-model="businessProfile.Address2"-->
<!--                  placeholder="Optional"-->
<!--                ></b-form-input>-->
<!--              </b-input-group>-->
<!--              <b-row style="align-items: center;">-->
<!--                <b-col>-->
<!--                  <b-input-group class="mt-4" prepend="Zip Code">-->
<!--                    <b-form-input-->
<!--                      v-model="businessProfile.ZIP"-->
<!--                    ></b-form-input> </b-input-group-->
<!--                ></b-col>-->
<!--                <b-col>-->
<!--                  <b-input-group class="mt-4" prepend="City">-->
<!--                    <b-form-input v-model="businessProfile.City"></b-form-input>-->
<!--                  </b-input-group>-->
<!--                  <b-input-group class="mt-4" prepend="State">-->
<!--                    <b-form-input-->
<!--                      v-model="businessProfile.State"-->
<!--                    ></b-form-input> </b-input-group-->
<!--                ></b-col>-->
<!--              </b-row>-->
<!--              &lt;!&ndash; Address Modal Save and Cancel button &ndash;&gt;-->
<!--              <template #modal-footer>-->
<!--                <div class="w-100">-->
<!--                  <b-button-->
<!--                    variant="warning"-->
<!--                    size="md"-->
<!--                    class="float-right ml-3"-->
<!--                    @click="updateAddress"-->
<!--                  >-->
<!--                    Save Changes-->
<!--                  </b-button>-->
<!--                  <b-button-->
<!--                    variant="outline-secondary"-->
<!--                    size="md"-->
<!--                    class="float-right"-->
<!--                    @click="addressModal = false"-->
<!--                  >-->
<!--                    Cancel-->
<!--                  </b-button>-->
<!--                </div>-->
<!--              </template>-->
<!--            </b-modal>-->
          </b-row>
          <!-- //Mobile View Restaurant Address -->

          <!-- Primary Phone Number -->
          <b-row style="padding-left: 12px;" class="py-4 d-none d-sm-flex">
            <b-col cols="10" lg="9">
              <label style="font-size: 0.875rem; font-weight: 400; color: gray;"
                >Primary Phone Number</label
              >
              <b-input-group
                :class="
                  readonlyPrimaryPhoneNumber ? 'remove-border-styling' : ''
                "
                prepend="+1"
              >
                <b-form-input
                  v-if="readonlyPrimaryPhoneNumber == true"
                  placeholder="Required"
                  class="myFeild"
                  :value="formatPhoneNumber(businessProfile.Phone1)"
                  :readonly="readonlyPrimaryPhoneNumber"
                  maxlength="18"
                  v-mask="['###-###-####']"
                ></b-form-input>
                <b-form-input
                  v-if="readonlyPrimaryPhoneNumber == false"
                  placeholder="Required"
                  class="myFeild"
                  v-model="businessProfile.Phone1"
                  :readonly="readonlyPrimaryPhoneNumber"
                  maxlength="18"
                ></b-form-input>
                
                <b-input-group-append>
                  <!-- Save button -->
                  <b-button
                    v-if="readonlyPrimaryPhoneNumber == false"
                    @click="updatePrimaryNumber"
                    size="sm"
                    :disabled="businessProfile.Phone1.length ? false : true"
                    variant="success"
                    >Save Changes</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="2" lg="3">
              <b-button
                class="pt-0"
                v-if="readonlyPrimaryPhoneNumber == true"
                @click="
                  () => {
                    readonlyPrimaryPhoneNumber = false;
                  }
                "
                variant="link"
                >Edit
              </b-button>
            </b-col>
          </b-row>
          <!-- Primary Phone Number -->

          <!-- Mobile View Primary Number -->
          <b-row class="py-4 my-3 d-block d-sm-none">
            <b-col cols="11">
              <b-row class="pl-2">
                <label
                  style="font-size: 0.875rem; font-weight: 400; color: gray;"
                  >Primary Phone Number</label
                ></b-row
              >
              <b-row :class="readonlyPrimaryPhoneNumber ? '' : 'pl-2'">
                <b-input-group
                  :class="
                    readonlyPrimaryPhoneNumber ? 'remove-border-styling' : ''
                  "
                  prepend="+1"
                >
                  <b-form-input
                    placeholder="Primary Phone Number (Required)"
                    v-model="businessProfile.Phone1"
                    class="myField"
                    :readonly="readonlyPrimaryPhoneNumber"
                    maxlength="16"
                    
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      v-if="readonlyPrimaryPhoneNumber == false"
                      @click="updatePrimaryNumber"
                      size="sm"
                      :disabled="businessProfile.Phone1.length ? false : true"
                      variant="success"
                      >Save</b-button
                    >
                    <b-button
                      v-if="readonlyPrimaryPhoneNumber == true"
                      @click="
                        () => {
                          readonlyPrimaryPhoneNumber = false;
                        }
                      "
                      variant="link"
                      >Edit
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-row>
            </b-col>
          </b-row>
          <!-- //Mobile View Primary Number -->

          <!-- Secondary Phone Number -->
          <b-row style="padding-left: 12px;" class="pb-2 d-none d-sm-flex">
            <b-col cols="10" lg="9">
              <label style="font-size: 0.875rem; font-weight: 400; color: gray;"
                >Secondary Phone Number</label
              >
              <b-input-group
                v-if="readonlySecondaryPhoneNumber == false"
                :class="
                  readonlySecondaryPhoneNumber ? 'remove-border-styling' : ''
                "
                prepend="+1"
              >
                <b-form-input
                  placeholder="Optional"
                  v-model="businessProfile.Phone2"
                  :value="formatPhoneNumber(businessProfile.Phone2)"
                  :readonly="readonlySecondaryPhoneNumber"
                  maxlength="12"
                  v-mask="['###-###-####']"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    v-if="readonlySecondaryPhoneNumber == false"
                    @click="updateSecondaryNumber"
                    variant="success"
                    size="sm"
                    >Save Changes</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="2" lg="3">
              <b-button
                class="pt-0"
                v-if="readonlySecondaryPhoneNumber == true"
                @click="
                  () => {
                    readonlySecondaryPhoneNumber = false;
                  }
                "
                variant="link"
                >Edit
              </b-button>
            </b-col>
          </b-row>
          <!-- //Secondary Phone Number -->

          <!-- Mobile View Secondary Phone Number -->
          <b-row class="pb-2 my-3 d-block d-sm-none">
            <b-col cols="11">
              <b-row class="pl-2">
                <label
                  style="font-size: 0.875rem; font-weight: 400; color: gray;"
                  >Secondary Phone Number</label
                ></b-row
              >
              <b-row :class="readonlySecondaryPhoneNumber ? '' : 'pl-2'">
                <b-input-group
                  :class="
                    readonlySecondaryPhoneNumber ? 'remove-border-styling' : ''
                  "
                  prepend="+1"
                >
                  <b-form-input
                    placeholder="Secondary Number (Optional)"
                    v-model="businessProfile.Phone2"
                    :readonly="readonlySecondaryPhoneNumber"
                    maxlength="12"
                    v-mask="['###-###-####']"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      v-if="readonlySecondaryPhoneNumber == false"
                      @click="updateSecondaryNumber"
                      variant="success"
                      size="sm"
                      >Save</b-button
                    >
                    <b-button
                      v-if="readonlySecondaryPhoneNumber == true"
                      @click="
                        () => {
                          readonlySecondaryPhoneNumber = false;
                        }
                      "
                      variant="link"
                      >Edit
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-row>
            </b-col>
          </b-row>
          <!-- //Mobile View Secondary Phone Number -->
        </b-col>

        <!-- Restaurant Type panel -->
        <b-col cols="12" lg="6">
          <!--Restaurant Type -->
          <b-row class="pb-3 d-none d-sm-flex">
            <b-col cols="10" lg="9">
              <b-input-group
                :class="readonlyRestaurantType ? 'remove-border-styling' : ''"
                prepend="Restaurant Type"
              >
                <b-form-select
                  :class="readonlyRestaurantType ? 'remove-border-styling' : ''"
                  :options="businessProfile.restaurantTypesCollection"
                  v-model="businessProfile.RestaurantType"
                  :disabled="readonlyRestaurantType"
                ></b-form-select>

                <b-input-group-append>
                  <b-button
                    v-if="readonlyRestaurantType == false"
                    @click="updateRestaurantType"
                    variant="success"
                    size="sm"
                    >Save Changes</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="2" lg="3">
              <b-button
                class="pt-0"
                v-if="readonlyRestaurantType == true"
                @click="
                  () => {
                    readonlyRestaurantType = false;
                  }
                "
                variant="link"
                >Edit
              </b-button>
            </b-col>
          </b-row>
          <!-- //Restaurant Type -->

          <!-- Mobile View Restaurant Type -->
          <b-row class="py-3 my-3 d-block d-sm-none">
            <b-col cols="11">
              <b-row class="pl-2"
                ><label
                  style="font-size: 0.875rem; font-weight: 400; color: gray;"
                  >Restaurant Type</label
                ></b-row
              >
              <b-row :class="readonlyRestaurantType ? '' : 'pl-2'">
                <b-input-group
                  :class="readonlyRestaurantType ? 'remove-border-styling' : ''"
                >
                  <b-form-select
                    :class="
                      readonlyRestaurantType ? 'remove-border-styling' : ''
                    "
                    :options="businessProfile.restaurantTypesCollection"
                    v-model="businessProfile.RestaurantType"
                    :disabled="readonlyRestaurantType"
                  ></b-form-select>

                  <b-input-group-append>
                    <b-button
                      v-if="readonlyRestaurantType == false"
                      @click="updateRestaurantType"
                      variant="success"
                      size="sm"
                      >Save</b-button
                    >
                    <b-button
                      v-if="readonlyRestaurantType == true"
                      @click="
                        () => {
                          readonlyRestaurantType = false;
                        }
                      "
                      variant="link"
                      >Edit
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-row>
            </b-col>
          </b-row>
          <!-- // Mobile View Restaurant Type -->

          <!-- Cuisine -->
          <b-row class="py-3 d-none d-sm-flex">
            <b-col cols="10" lg="9">
              <b-input-group
                :class="readonlyCuisine ? 'remove-border-styling' : ''"
                prepend-html='<div class="d-flex h-100 py-2">Venue Type</div>'
              >
                <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
                <b-form-tags
                  id="tags-component-select"
                  v-model="value"
                  size="lg"
                  placeholder="Required"
                  :disabled="readonlyCuisine"
                  add-on-change
                  no-outer-focus
                >
                  <template
                    v-slot="{
                      tags,
                      inputAttrs,
                      inputHandlers,
                      disabled,
                      removeTag,
                    }"
                  >
                    <ul
                      v-if="tags && tags.length > 0"
                      class="list-inline d-inline-block mb-2"
                    >
                      <li
                        v-for="tag in tags"
                        :key="tag"
                        class="list-inline-item"
                      >
                        <b-form-tag
                          @remove="removeTag(tag)"
                          :title="tag"
                          :disabled="disabled"
                          :variant="
                            readonlyCuisine == false ? 'warning' : 'white'
                          "
                          >{{ tag }}</b-form-tag
                        >
                      </li>
                    </ul>
                    <b-form-select
                      v-bind="inputAttrs"
                      v-on="inputHandlers"
                      :disabled="
                        disabled ||
                          (availableOptions && availableOptions.length === 0)
                      "
                      :class="
                        disabled ||
                        (availableOptions && availableOptions.length === 0)
                          ? 'd-none'
                          : 'd-flex'
                      "
                      :options="availableOptions"
                    >
                      <template #first>
                        <!-- This is required to prevent bugs with Safari -->
                        <option disabled value="">Choose a tag...</option>
                      </template>
                    </b-form-select>
                  </template>
                </b-form-tags>

                <b-input-group-append>
                  <b-button
                    v-if="readonlyCuisine == false"
                    @click="updateCuisine"
                    variant="success"
                    size="sm"
                    >Save Changes</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-col>
            
            <b-col cols="2" lg="3">
              <b-button
                v-if="readonlyCuisine == true"
                @click="
                  () => {
                    readonlyCuisine = false;
                  }
                "
                variant="link"
                >Edit
              </b-button>
            </b-col>
          </b-row>
          <b-row class="pb-3 d-none d-sm-flex">
            <b-col cols="10" lg="9">
              <b-input-group
                :class="readonlyMenuFocus ? 'remove-border-styling' : ''"
                prepend="Menu Focus"
              >
                <b-form-select
                  :class="readonlyMenuFocus ? 'remove-border-styling' : ''"
                  :options="menuFocusArray"
                  v-model="menuFocus"
                  :disabled="readonlyMenuFocus"
                ></b-form-select>

                <b-input-group-append>
                  <b-button
                    v-if="readonlyMenuFocus == false"
                    @click="updateMenuFocus"
                    variant="success"
                    size="sm"
                    >Save Changes</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="2" lg="3">
              <b-button
                class="pt-0"
                v-if="readonlyMenuFocus == true"
                @click="
                  () => {
                    readonlyMenuFocus = false;
                  }
                "
                variant="link"
                >Edit
              </b-button>
            </b-col>
          </b-row>
          
          <!-- //Cuisine -->

          <!-- Mobile View Cuisine -->
          <b-row class="py-3 my-3 d-block d-sm-none">
            <b-col cols="11">
              <b-row class="pl-2"
                ><label
                  style="font-size: 0.875rem; font-weight: 400; color: gray;"
                  >Cuisine</label
                ></b-row
              >
              <b-row :class="readonlyCuisine ? '' : 'pl-2'">
                <b-input-group
                  :class="readonlyCuisine ? 'remove-border-styling' : ''"
                >
                  <b-form-tags
                    id="tags-component-select"
                    v-model="value"
                    size="lg"
                    placeholder="Required"
                    :disabled="readonlyCuisine"
                    add-on-change
                    no-outer-focus
                  >
                    <template
                      v-slot="{
                        tags,
                        inputAttrs,
                        inputHandlers,
                        disabled,
                        removeTag,
                      }"
                    >
                      <ul
                        v-if="tags && tags.length > 0"
                        class="list-inline d-inline-block mb-2"
                      >
                        <li
                          v-for="tag in tags"
                          :key="tag"
                          class="list-inline-item"
                        >
                          <b-form-tag
                            @remove="removeTag(tag)"
                            :title="tag"
                            :disabled="disabled"
                            variant="warning"
                            >{{ tag }}</b-form-tag
                          >
                        </li>
                      </ul>
                      <b-form-select
                        v-bind="inputAttrs"
                        v-on="inputHandlers"
                        :disabled="
                          disabled ||
                            (availableOptions && availableOptions.length === 0)
                        "
                        :class="
                          disabled ||
                          (availableOptions && availableOptions.length === 0)
                            ? 'd-none'
                            : 'd-flex'
                        "
                        :options="availableOptions"
                      >
                        <template #first>
                          <option disabled value="">Choose a tag...</option>
                        </template>
                      </b-form-select>
                    </template>
                  </b-form-tags>

                  <b-input-group-append>
                    <b-button
                      v-if="readonlyCuisine == false"
                      @click="updateCuisine"
                      variant="success"
                      size="sm"
                      >Save</b-button
                    >
                    <b-button
                      v-if="readonlyCuisine == true"
                      @click="
                        () => {
                          readonlyCuisine = false;
                        }
                      "
                      variant="link"
                      >Edit
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-row>
            </b-col>
          </b-row>
          <!-- //Mobile View Cuisine -->

          <!-- Time Zone -->
          <b-row class="py-3">
            <b-col cols="11" sm="7">
              <b-input-group class="pl-2" prepend="Time Zone">
                <b-form-select
                  v-model="timeZone"
                  disabled
                  style="background:#ffff"
                  :options="timeZonesArray.map(el=>el.text)"
                ></b-form-select>
              </b-input-group>
            </b-col>

            <b-col cols="3" sm="3"> </b-col>
          </b-row>
          <!-- Time Zone -->
        </b-col>
      </b-row>
      <!-- //Restaurant Details -->
      <hr />
      <!-- Image Section -->
      <b-row>
        <!-- Cover Image -->
        <b-col class="px-5" cols="12" lg="8">
          <!-- Cover image -->
          <b-row class="justify-content-center">
            <b-img
              class="cover-img"
              :src="coverImagePayload.coverImageDataWithbase64"
              fluid
              alt="Responsive image"
            ></b-img>
          </b-row>
          <b-row class="justify-content-center">
            <b-col cols="6" lg="3">
              <b-button
                @click="
                  coverImagePayload.changeCoverModal = !coverImagePayload.changeCoverModal
                "
                variant="link"
              >
                <label>
                  Change Cover Photo
                </label>
              </b-button>

              <!-- Update Cover Image Modal -->
              <b-modal
                v-model="coverImagePayload.changeCoverModal"
                hide-footer
                size="lg"
                title="Change Cover Photo"
              >
                <!-- Buttons -->
                <b-row class="justify-content-center">
                  <!-- Change Button -->
                  <b-col
                    class="text-center"
                    style="border-right:1px solid black"
                  >
                    <h5
                      class="text-secondary my-5"
                      style="font-size:14px; color:#607D8B !important"
                    >
                      Upload a jpg, png, or gif file under 20MB in size.
                    </h5>
                    <h5
                      class="text-secondary my-5"
                      style="font-size:14px; color:#607D8B !important"
                    >
                      Resolution 1200 by 300 pixels looks best.
                    </h5>
                    <b-button class="bg-warning text-light py-0 pt-2 mb-4 ">
                      <label for="coverImage">
                        <b>Change Cover Photo</b>
                      </label>
                    </b-button>
                    <b-form-file
                      id="coverImage"
                      style="display:none;"
                      @change="setUploadCoverImageProperty"
                    />
                  </b-col>

                  <!-- Delete Button -->
                  <b-col
                    :class="
                      coverImagePayload.coverImageFromServer.length
                        ? 'd-block text-center'
                        : 'd-none'
                    "
                  >
                    <h5
                      class="text-secondary my-5"
                      style="font-size:14px; color:#607D8B !important"
                    >
                      Delete existing cover photo.
                    </h5>
                    <h5
                      class="text-secondary my-5"
                      style="font-size:14px; color:#607D8B !important"
                    >
                      No Replacement is provided.
                    </h5>
                    <b-button
                      @click="deleteCoverPhoto"
                      class="bg-warning text-light py-2 mb-4"
                    >
                      <b>Delete Cover Photo</b>
                    </b-button>
                  </b-col>
                </b-row>
              </b-modal>
              <!-- Crop cover Image Modal -->
              <b-modal
                v-model="coverImagePayload.cropCoverImageModal"
                hide-footer
                size="xl"
                title="Change Cover Photo"
              >
                <!-- Buttons -->
                <b-row class="justify-content-center">
                  <!-- Change Button -->
                  <b-col
                    class="text-center"
                    style="border-right:1px solid black"
                  >
                    <h5 class="text-secondary my-5" style="font-size:14px">
                      <b>Crop Image</b>
                    </h5>
                    <b-row style="justify-content:center;" class="text-center">
                      <ImageCropper
                        v-if="
                          coverImagePayload &&
                            coverImagePayload.coverImageData.length > 0 &&
                            this.coverImagePayload.coverImage
                        "
                        :src="coverImagePayload.coverImageData"
                        :coverImage="coverImagePayload.coverImage"
                        v-on:cropImageData="setCropImageData($event)"
                        v-on:cropLogoImageData="setLogoCropImageData($event)"
                      />
                    </b-row>
                    <b-button
                      @click="uploadCoverPhoto"
                      class="bg-warning text-light py-1 px-4 mb-4 mt-4"
                    >
                      <b>Crop and Upload</b>
                    </b-button>
                    <b-button
                      @click="coverImagePayload.cropCoverImageModal = false"
                      class="bg-warning text-light py-1 px-5 mb-4 mt-4 ml-3"
                    >
                      <b> Cancel</b>
                    </b-button>
                  </b-col>
                </b-row>
              </b-modal>
            </b-col>
          </b-row>
        </b-col>

        <!-- Logo Image -->
        <b-col cols="12" lg="4">
          <b-row class="justify-content-center d-flex flex-column">
            <b-img
              fluid
              :src="logoImagePayload.logoImageDataWithbase64"
              class="logo-img w-100"
              alt="Image 1"
            ></b-img>
            <b-button
              @click="
                logoImagePayload.changeLogoModal = !logoImagePayload.changeLogoModal
              "
              variant="link"
            >
              <label>
                Change Logo Image
              </label>
            </b-button>
          </b-row>

          <b-row class="justify-content-center">
            <b-col cols="6" lg="5">
              <b-modal
                v-model="logoImagePayload.changeLogoModal"
                hide-footer
                size="lg"
                title="Change Logo Image"
              >
                <!-- Buttons -->
                <b-row class="justify-content-center">
                  <b-col
                    class="text-center"
                    style="border-right:1px solid black"
                  >
                    <h5
                      class="text-secondary my-5"
                      style="font-size:14px; color:#607D8B !important"
                    >
                      Upload a jpg, png, or gif file under 20MB with a square
                      size aspect ratio (1:1).
                    </h5>
                    <b-button class="bg-warning text-light py-0 pt-2 mb-4">
                      <label for="logoImage">
                        <b>Change Logo Image</b>
                      </label>
                    </b-button>
                    <b-form-file
                      id="logoImage"
                      style="display:none;"
                      @change="setUploadLogoImageProperty"
                    />
                  </b-col>
                  <b-col
                    :class="
                      logoImagePayload.logoImageFromServer.length
                        ? 'd-block text-center'
                        : 'd-none'
                    "
                  >
                    <h5
                      class="text-secondary my-5"
                      style="font-size:14px; color:#607D8B !important"
                    >
                      Delete existing logo image. No Replacement is provided.
                    </h5>
                    <b-button
                      @click="deleteLogoPhoto"
                      class="bg-warning text-light py-2 mb-4 "
                    >
                      <b>Delete logo Image</b>
                    </b-button>
                  </b-col>
                </b-row>
              </b-modal>
              <!-- Crop Logo Image Modal -->
              <b-modal
                v-model="logoImagePayload.cropLogoImageModal"
                hide-footer
                size="xl"
                title="Change Logo Photo"
              >
                <!-- Buttons -->
                <b-row class="justify-content-center">
                  <!-- Change Button -->
                  <b-col
                    class="text-center"
                    style="border-right:1px solid black"
                  >
                    <h5 class="text-secondary my-5" style="font-size:14px">
                      Crop Image
                    </h5>
                    <b-row style="justify-content:center;" class="text-center">
                      <ImageCropper
                        v-if="
                          logoImagePayload &&
                            logoImagePayload.logoImageData.length > 0 &&
                            this.logoImagePayload.logoImage
                        "
                        :src="logoImagePayload.logoImageData"
                        :logoImage="logoImagePayload.logoImage"
                        v-on:cropImageData="setCropImageData($event)"
                        v-on:cropLogoImageData="setLogoCropImageData($event)"
                      />
                      <!-- <ImageCropper src="/img/logo-full.png" />  -->
                      <!-- <img src="img/back_doitbetter-1200x300.jpg" />  -->
                    </b-row>
                    <b-button
                      @click="uploadLogoPhoto"
                      class="bg-warning text-light py-1 px-4 mb-4 mt-4"
                    >
                      <b>Crop and Upload</b>
                    </b-button>
                    <b-button
                      @click="logoImagePayload.cropLogoImageModal = false"
                      class="bg-warning text-light py-1 px-5 mb-4 mt-4 ml-3"
                    >
                      <b>Cancel</b>
                    </b-button>
                  </b-col>
                </b-row>
              </b-modal>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <!-- Schedule Section -->
      <OperationSchedule />
      <!-- Restaurant Attributes -->
      <RestaurantAttributes
        ref="restaurantAttributes"
        v-on:updateRestaurantProfile="GetRestaurantProfile()"
      />

      <!-- Restaurant Attributes Comments-->
      <b-row class="d-none d-sm-flex">
        <b-col sm="8">
          <b-row>
            <b-col sm="4"
              ><label for="input-default" class="mt-1"
                >Restaurant Attributes Comments</label
              ></b-col
            >
            <b-col sm="8">
              <b-form-textarea
                id="textarea-auto-height"
                placeholder="Optional"
                class="myFeild"
                v-model="businessProfile.AttrComment"
                :readonly="readonlyRestaurantAttributesComments"
                :class="
                  readonlyRestaurantAttributesComments
                    ? 'text-area-styling'
                    : ''
                "
                @keyup="disableSaveButton = false"
              ></b-form-textarea>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="2">
          <b-button
            v-if="readonlyRestaurantAttributesComments == true"
            @click="
              () => {
                readonlyRestaurantAttributesComments = false;
              }
            "
            variant="link"
            >Edit
          </b-button>

          <b-button
            v-if="readonlyRestaurantAttributesComments == false"
            @click="updateRestaurantAttributeComments"
            variant="success"
            size="sm"
            :disabled="disableSaveButton"
            >Save Changes</b-button
          >
        </b-col>
      </b-row>
      <!-- //Restaurant Attributes Comments -->

      <!-- Mobile View Restaurant Attributes Comments -->
      <b-row class="my-5 d-block d-sm-none">
        <b-col cols="11">
          <b-row class="pl-2">
            <label for="input-default" class="mt-1"
              >Restaurant Attributes Comments</label
            >
          </b-row>

          <b-row :class="readonlyRestaurantAttributesComments ? '' : 'pl-2'"
            ><b-input-group
              :class="
                readonlyRestaurantAttributesComments
                  ? 'remove-border-styling'
                  : 'px-0'
              "
            >
              <b-form-textarea
                id="textarea-auto-height"
                placeholder="Enter Restaurant Attributes Comments"
                v-model="businessProfile.AttrComment"
                :readonly="readonlyRestaurantAttributesComments"
                :class="
                  readonlyRestaurantAttributesComments
                    ? 'text-area-styling'
                    : ''
                "
                @keyup="disableSaveButton = false"
              ></b-form-textarea>

              <b-input-group-append>
                <b-button
                  v-if="readonlyRestaurantAttributesComments == true"
                  @click="
                    () => {
                      readonlyRestaurantAttributesComments = false;
                    }
                  "
                  variant="link"
                  >Edit
                </b-button>

                <b-button
                  v-if="readonlyRestaurantAttributesComments == false"
                  @click="updateRestaurantAttributeComments"
                  variant="success"
                  size="sm"
                  :disabled="disableSaveButton"
                  >Save</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-row>
        </b-col>
        <b-col sm="2"> </b-col>
      </b-row>
      <!-- //Mobile View Restaurant Attributes Comments -->
    </b-card>
  </div>
</template>

<script>
import RestaurantAttributes from "./Business Profile/restaurantAttributes.vue";
import OperationSchedule from "./Business Profile/operationSchedule.vue";
import * as types from "@/store/types";
import ImageCropper from "./Business Profile/imageCropper.vue";
import logoDefaultImage from "../../assets/image/upload-photo.png";
import config from 'SrcConfig';
import {getGeoCode} from "../../lib/searchAddress";

import { mapGetters } from "vuex";
import CModal from "../shared/Cmodal";
export default {
  name: "businessProfile",
  components: {
      CModal,
    RestaurantAttributes,
    OperationSchedule,
    ImageCropper,
  },
  data() {
    return {
      businessProfile: {
        Address1: "",
        Address2: "",
        Attire: "",
        AttrComment: "",
        CanChangePhotos: "",
        ChainId: 0,
        City: "",
        Country: "",
        CoverPhoto: null,
        CoverPhoto360: null,
        Cuisine: "",
        DrinkThreshold: 0,
        Phone1: "",
        Phone2: "",
        RestaurantID: "",
        RestaurantName: "",
        RestaurantType: "",
        ZIP: "",
      },
      cuisineArray: [],
      menuFocusArray: [
        { value: "Food", text: "Food" },
        { value: "Drink", text: "Drink" },
      ],

      value: [],
      url: null,
      timeZone: "",
      timeZonesArray: [{ value: "GMT", text: "GMT" }],
      readonlyRestaurantName: true,
      readonlyRestaurantAddress: true,
      readonlyCuisine: true,
      readonlyPrimaryPhoneNumber: true,
      readonlySecondaryPhoneNumber: true,
      readonlyRestaurantType: true,
      readonlyRestaurantAttributesComments: true,
      readonlyMenuFocus: true,
      menuFocus: "Food",
      addressModal: false,

      logoImage: false,
      image: null,
      changeLogoModal: false,

      // logoImageData: {},
      disableSaveButton: true,

      coverImagePayload: {
        coverImage: false,
        coverImageDataWithbase64: "",
        coverImageData: "",
        coverImageName: "",
        changeCoverModal: false,
        cropCoverImageModal: false,
        coverImageFromServer: "",
      },

      logoImagePayload: {
        logoImage: false,
        logoImageDataWithbase64: "",
        logoImageData: "",
        logoImageName: "",
        changeLogoModal: false,
        cropLogoImageModal: false,
        logoImageFromServer: "",
      },
    };
  },

  mounted() {
    this.GetRestaurantProfile();
    this.GetRestaurantMenuFocus();
    this.cuisineArray = [];
    this.value = [];
  },

  computed: {
    ...mapGetters([
      "businessProfileGetter",
      // ...
    ]),
    availableOptions() {
      //console.log(this.cuisineArray, this.value);
      return (
        this.cuisineArray &&
        this.cuisineArray.filter((opt) => this.value.indexOf(opt) === -1)
      );
    },
    
  },

  methods: {
    updateMenuFocus() {
      let model = {
        RestaurantID: localStorage.getItem("selectedRestaurant"),
        UserID: localStorage.getItem("userID"),
        MenuFocus: this.menuFocus,
      };
      this.$api.getRestaurant.UpdateMenuFocus(model).then((res) => {
        if (res.success) {
          this.GetRestaurantMenuFocus();
          this.readonlyMenuFocus = true;
        }
      });
    },
    GetRestaurantMenuFocus() {
      let model = {
        RestaurantID: localStorage.getItem("selectedRestaurant"),
        // UserID: localStorage.getItem("userID"),
      };
      this.$api.publicClient.GetRestaurantInfo(model).then((res) => {

        if (res.success) {
          this.menuFocus = res.results.myMenuFocus;
        }
      });
    },
    formatPhoneNumber(phone) {
      return phone ? phone.replace(/(\d{3})(\d{3})(\d{0,4})/, '$1-$2-$3') : '';
    },
    updateRestaurantName() {
      if (
        this.businessProfile &&
        this.businessProfile.RestaurantName.length > 0
      ) {
        this.disableSaveButton = true;
        this.readonlyRestaurantName = true;
        this.$store.commit(types.BUSINESS_PROFILE, this.businessProfile);
        this.updateRestaurantProfile();
      }
    },

    updateRestaurantAttributeComments() {
      this.disableSaveButton = true;
      this.readonlyRestaurantAttributesComments = true;
      this.$store.commit(types.BUSINESS_PROFILE, this.businessProfile);
      this.$api.getRestaurant
        .UpdateServices(this.businessProfile)
        .then((res) => {
          if (res) {
            this.GetRestaurantProfile();
          }
        });
    },

    updateAddress() {
      if (this.businessProfile && this.businessProfile.Address1.length > 0) {
        this.disableSaveButton = true;
        this.addressModal = false;
        this.$store.commit(types.BUSINESS_PROFILE, this.businessProfile);
        this.UpdateRestaurantLanLat(this.businessProfile)
        this.updateRestaurantProfile();
      }
    },

    UpdateRestaurantLanLat (data) {
      const {Address1, Address2, Country, City, State, ZIP, Latitude, Longitude} = data

      // businessProfile.Address1
      getGeoCode(Address1).then(res => {
        //console.log(res)
        const locations = res.geometry.location
        let model = {}
        if (locations) {
          model = {
            Address1, Address2, Country, City, State, ZIP, Latitude: locations.lat, Longitude: locations.lng,
            // UserID: localStorage.getItem('userID'),
            RestaurantID: this.$store.state.selectedRestaurantId,
          }
        } else {
          model = {
            Address1, Address2, Country, City, State, ZIP, Latitude, Longitude,
            // UserID: localStorage.getItem('userID'),
            RestaurantID: this.$store.state.selectedRestaurantId,
          }
        }
        return this.$api.getRestaurant.UpdateRestaurantLanLat(model).then(res => {
          if (res.success) {

          } else {
            this.$showError('error on update location restaurant')
          }
        }).catch(() => {})
      })


    },

    updatePrimaryNumber() {
      if (this.businessProfile && this.businessProfile.Phone1.length > 0) {
        this.disableSaveButton = true;
        this.readonlyPrimaryPhoneNumber = true;
        let model = this.businessProfile
        if(model.Phone1.indexOf("-") != -1){
          model.Phone1 = model.Phone1.replaceAll("-","")
        }
        if(model.Phone1.indexOf("(") != -1){
          model.Phone1 = model.Phone1.replaceAll("(","")
        }
        if(model.Phone1.indexOf(")") != -1){
          model.Phone1 = model.Phone1.replaceAll(")","")
        }
        if(model.Phone1.indexOf(" ") != -1){
          model.Phone1 = model.Phone1.replaceAll(" ","")
        }
        if(model.Phone2.indexOf("-") != -1){
          model.Phone2 = model.Phone2.replaceAll("-","")
        }
        // Remove all instances of '+1' and leave only one at the beginning if necessary
        let phone1 = model.Phone1.replaceAll("+1", "");
        
        model.Phone1 = phone1;

        let phone2 = model.Phone2.replaceAll("+1", "");
        
        model.Phone2 = phone2;
        
      
        
        
      
        
        this.$store.commit(types.BUSINESS_PROFILE, model);
        this.updateRestaurantProfile();
      }
    },
    updateSecondaryNumber() {
      this.disableSaveButton = true;
      this.readonlySecondaryPhoneNumber = true;
      let model = this.businessProfile
      
      
      if(model.Phone1.indexOf("-") != -1){
        model.Phone1 = model.Phone1.replaceAll("-","")
      }

      if(model.Phone2.indexOf("-") != -1){
        model.Phone2 = model.Phone2.replaceAll("-","")
      }
      
      this.$store.commit(types.BUSINESS_PROFILE, model);
      this.updateRestaurantProfile();
    },
    updateRestaurantType() {
      this.disableSaveButton = true;
      this.readonlyRestaurantType = true;
      this.$store.commit(types.BUSINESS_PROFILE, this.businessProfile);
      this.updateRestaurantProfile();
    },
    updateCuisine() {
      this.disableSaveButton = true;
      this.readonlyCuisine = true;
      this.businessProfile.Cuisine = this.value.join();
      this.$store.commit(types.BUSINESS_PROFILE, this.businessProfile);
      this.updateRestaurantProfile();
    },

    // Cover Photo
    setUploadCoverImageProperty(e) {
      this.coverImagePayload.coverImage = true;
      this.coverImagePayload.changeCoverModal = false;
      this.coverImagePayload.cropCoverImageModal = true;
      let file = e.target.files[0];
      this.coverImagePayload.coverImageName = file.name;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.coverImagePayload.coverImageData = e.target.result;
      };
      reader.readAsDataURL(file);
      this.coverImagePayload.changeCoverModal = false;
    },
    uploadCoverPhoto() {
      this.coverImagePayload.cropCoverImageModal = false;
      this.coverImagePayload.coverImageData = this.coverImagePayload.coverImageData.split(
        ","
      )[1];
      let model = {
        // UserID: localStorage.getItem("userID"),
        RestaurantID: localStorage.getItem("selectedRestaurant"),
        uploadCoverPhotoStr: this.coverImagePayload.coverImageData,
        FileName: this.coverImagePayload.coverImageName,
      };
      this.$api.getRestaurant.UploadCoverPhoto(model).then((res) => {
        //console.log(res);
        this.coverImagePayload.coverImage = false;
        this.coverImagePayload.coverImageData = "";
        this.coverImagePayload.coverImageName = "";
        this.coverImagePayload.changeCoverModal = false;
        this.coverImagePayload.cropCoverImageModal = false;
        this.GetRestaurantProfile();
      });
    },
    setCropImageData(imageData) {
      this.coverImagePayload.coverImageData = imageData;
      this.coverImagePayload.coverImageDataWithbase64 = imageData;
    },
    deleteCoverPhoto() {
      let model = {
        // UserID: localStorage.getItem("userID"),
        RestaurantID: localStorage.getItem("selectedRestaurant"),
        FolderID: this.businessProfile.FolderId,
      };
      this.$api.getRestaurant.DeleteCoverImage(model).then((res) => {
        this.coverImagePayload.coverImageDataWithbase64 = "";
        this.coverImagePayload.changeCoverModal = false;
        this.coverImagePayload.cropCoverImageModal = false;
        this.GetRestaurantProfile();
      });
    },

    // Logo Photo
    setUploadLogoImageProperty(e) {
      this.logoImagePayload.logoImage = true;
      this.logoImagePayload.changeLogoModal = false;
      this.logoImagePayload.cropLogoImageModal = true;
      let file = e.target.files[0];
      this.logoImagePayload.logoImageName = file.name;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.logoImagePayload.logoImageData = e.target.result;
      };
      reader.readAsDataURL(file);
      this.logoImagePayload.changeLogoModal = false;
    },
    uploadLogoPhoto() {
      this.logoImagePayload.cropLogoImageModal = false;
      this.logoImagePayload.logoImageData = this.logoImagePayload.logoImageData.split(
        ","
      )[1];
      let model = {
        // UserID: localStorage.getItem("userID"),
        RestaurantID: localStorage.getItem("selectedRestaurant"),
        uploadLogoStr: this.logoImagePayload.logoImageData,
        FileName: this.logoImagePayload.logoImageName,
      };
      this.$api.getRestaurant.UploadLogoPhoto(model).then((res) => {
        //console.log(res);
        this.logoImagePayload.logoImage = false;
        this.logoImagePayload.logoImageData = "";
        this.logoImagePayload.logoImageName = "";
        this.logoImagePayload.changeLogoModal = false;
        this.logoImagePayload.cropLogoImageModal = false;
        this.GetRestaurantProfile();
      });
    },
    setLogoCropImageData(imageData) {
      this.logoImagePayload.logoImageData = imageData;
      this.logoImagePayload.logoImageDataWithbase64 = imageData;
    },
    deleteLogoPhoto() {
      let model = {
        // UserID: localStorage.getItem("userID"),
        RestaurantID: localStorage.getItem("selectedRestaurant"),
        FolderID: this.businessProfile.FolderId,
      };
      this.$api.getRestaurant.DeleteLogoImage(model).then((res) => {
        this.logoImagePayload.logoImageDataWithbase64 = "";
        this.logoImagePayload.changeLogoModal = false;
        this.logoImagePayload.cropLogoImageModal = false;
        this.GetRestaurantProfile();
      });
    },

    updateRestaurantProfile() {
      let type =
        this.businessProfile &&
        this.businessProfile.restaurantTypesCollection.filter((item) => {
          if (item.text == this.businessProfile.RestaurantType) {
            return item;
          }
        });
      this.businessProfile.RestaurantType = type[0].index;
      this.$store.commit(types.BUSINESS_PROFILE, this.businessProfileGetter);

      
      
      
      
      let model = JSON.parse(JSON.stringify(this.businessProfileGetter))
      ////////////
      /////
        //add country code logic here 
      ////
      /////////
      model.Phone1 = "+1" + model.Phone1
      model.Phone2 = "+1" + model.Phone2
      
      this.$api.getRestaurant.UpdateRestaurantProfile(model)
        .then((res) => {
          if (res) {
            this.GetRestaurantProfile();
          }
        });
    },

    GetRestaurantProfile() {
      let model = {
        RestaurantID: localStorage.getItem("selectedRestaurant"),
        // UserID: localStorage.getItem("userID"),
      };

      this.$api.getRestaurant.GetRestaurantProfile(model).then((res) => {
        (res.results.RestaurantID = localStorage.getItem("selectedRestaurant")),
          (res.results.UserID = localStorage.getItem("userID"));
        //console.log(res.results, "res");


        /** Set Cover Image Property */
        this.coverImagePayload.coverImageDataWithbase64 =
         config.files.baseurlimage + res.results.CoverPhoto;
        if(config.files.baseurlimage.search('www') != -1){
          this.logoImagePayload.logoImageDataWithbase64 = "https://images.menupoly.com" + res.results.LogoImage;
        } else {
          this.logoImagePayload.logoImageDataWithbase64 = config.files.baseurlimage + res.results.LogoImage;
        }


        this.logoImagePayload.logoImageFromServer = res.results.LogoImage;
        this.coverImagePayload.coverImageFromServer = res.results.CoverPhoto;

        /**Setting Time Zones Array */
        res &&
          res.TimeZones.filter((timezone) => {
            this.timeZonesArray.push({
              text: timezone.Text,
              value: timezone.Value,
            });
            
            if (timezone.Value == `${res.results.TimeZoneOffset}.00`) {
              
              this.timeZone = timezone.Text
              
            }
          });
          
          

        /**Setting Cusine Array */
        let setCusineArray = {
          cusineArr: res.Cuisines.map((x) => x.Cuisine),
          value: res.results.Cuisine.split(","),
        };
        this.cuisineArray = setCusineArray.cusineArr;
        this.value = setCusineArray.value;

        /** Setting Restaurant Types*/
        let restaurantTypes = [];
        res &&
          res.RestaurantTypes.filter((item) => {
            restaurantTypes.push({
              value: item.RestaurantTypeDESC,
              text: item.RestaurantTypeDESC,
              index: item.RestaurantTypeID,
            });
          });
        res.results.restaurantTypesCollection = restaurantTypes;
        
        
        /**Setting Store values of API reponse */
        
        let tempModel =  JSON.parse(JSON.stringify(res.results));

        if(tempModel.Phone1.indexOf('-') != -1){
          tempModel.Phone1 = tempModel.Phone1.replaceAll("-","")
        }
        if(tempModel.Phone1.indexOf('+1') != -1){
          tempModel.Phone1 = tempModel.Phone1.replaceAll("+1","")
        }
        if(tempModel.Phone1.indexOf('(') != -1){
          tempModel.Phone1 = tempModel.Phone1.replaceAll("(","")
        }
        if(tempModel.Phone1.indexOf(')') != -1){
          tempModel.Phone1 = tempModel.Phone1.replaceAll(")","")
        }
        if(tempModel.Phone1.indexOf(' ') != -1){
          tempModel.Phone1 = tempModel.Phone1.replaceAll(" ","")
        }
        
        
        if(tempModel.Phone2.indexOf('-') != -1){
          tempModel.Phone2 = tempModel.Phone2.replaceAll("-","")
        }
        if(tempModel.Phone2.indexOf('+1') != -1){
          tempModel.Phone2 = tempModel.Phone2.replaceAll("+1","")
        }
        if(tempModel.Phone2.indexOf('(') != -1){
          tempModel.Phone2 = tempModel.Phone2.replaceAll("(","")
        }
        if(tempModel.Phone2.indexOf(')') != -1){
          tempModel.Phone2 = tempModel.Phone2.replaceAll(")","")
        }
        if(tempModel.Phone2.indexOf(' ') != -1){
          tempModel.Phone2 = tempModel.Phone2.replaceAll(" ","")
        }

        this.businessProfile = tempModel
        this.$refs.restaurantAttributes.updateRestaurantAttributes(
          this.businessProfile
        )
        this.$store.commit(types.BUSINESS_PROFILE, res.results);


        
        
        
        
      });
    },
  },
};
</script>

<style scoped lang="scss">
.header-color {
  background-color: #3f4d5a;
}

.text-area-styling {
  border: none !important;
  box-shadow: none !important;
}

::placeholder {
  color: #cfd8dc !important;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #ffff !important;
  opacity: 1;
}

.remove-border-styling {
  .input-group-prepend {
    background: #fff !important;
    border: none !important;
  }
  .input-group-text {
    background: #fff !important;
    border: none !important;
  }
  .form-control {
    border: none !important;
    background-color: #ffff !important;
  }
  .custom-select {
    border: none !important;
    box-shadow: none !important;
    background: #fff;
  }
}

.address-input {
  border: none !important;
  box-shadow: none !important;
  background: #fff;
}

.cover-img {
  width: 1200px;
  height: 300px;
  object-fit: none;
}
.logo-img {
  width: 300px;
  height: 300px;
  object-fit: none;
}
</style>
